/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var ContactsIcon = createIcon("ContactsIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 19V7c0-1.103-.897-2-2-2H4c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h18c1.103 0 2-.897 2-2Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 17V5c0-1.103-.897-2-2-2H2C.897 3 0 3.897 0 5v12c0 1.103.897 2 2 2h18c1.103 0 2-.897 2-2Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 7c1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2 .897-2 2-2Zm4 7.031c0 .534-.448.969-1 .969H4c-.552 0-1-.435-1-.969v-.228c0-.665.388-1.265 1.013-1.566C4.712 11.9 5.797 11.5 7 11.5s2.288.4 2.987.737c.625.3 1.013.9 1.013 1.566v.228Z",
    fill: "#2071C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 15h-6a.5.5 0 110-1h6a.5.5 0 110 1Zm0-3h-6a.5.5 0 110-1h6a.5.5 0 110 1Zm0-3h-6a.5.5 0 110-1h6a.5.5 0 110 1Z",
    fill: "#666"
  })));
}, {});